import { Component, Input, ChangeDetectorRef, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { Editor } from 'primeng/editor';
import { getProvider } from '../../../../Common/Forms/models/control-value-accessor.model';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-content-editable-box',
    templateUrl: './content-editable-box.component.html',
    styleUrls: ['./content-editable-box.component.scss'],
    providers: [getProvider(ContentEditableBoxComponent)],
    standalone: false
})
export class ContentEditableBoxComponent implements ControlValueAccessor {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() id: string;
    @Input() boxStyle;
    @Input() showDelete: boolean = false;
    @Input() placeholder: string;
    @Input() placeholderIcon: string;
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onDeleteClick: EventEmitter<any> = new EventEmitter();
    @Output() moveUp: EventEmitter<any> = new EventEmitter();
    @Output() moveDown: EventEmitter<any> = new EventEmitter();
    @Input() showMoveButtons: boolean = false;
    @Input() moveUpDisabled: boolean = false;
    @Input() moveDownDisabled: boolean = false;
    @Input() isRetracted: boolean = false;
    @Input() maxLength: number = 0;
    @Input() maxHtmlContentLength: number = 0;
    @Input() htmlContentLimitExceedMessage: string;
    @Input() errorsId: string;
    @Input() ariaLabel: string;

    @ViewChild('editor') quillEditor: Editor;

    public editable: boolean = false;
    public content: string = '';
    constructor(
        private changeDetector: ChangeDetectorRef,
        private elementRef: ElementRef
    ) {}

    registerOnTouched(fn: () => void): void { }
    propagateChange: any = () => { };

    writeValue(value: any): void {
        if (value) {
            this.content = this.filterHTMLTags(value + '');
        } else {
            this.content = '';
        }
    }

    registerOnChange(fn): void {
        this.propagateChange = fn;
    }

    public onEdit($event): void {
        if (this.isRetracted) {
            return;
        }
        if (this.content === undefined ||
                this.content === null ||
                this.content === ''
        ) {
            this.content = ' ';
        }
        this.editable = true;
        this.changeDetector.detectChanges();
    }

    public onDelete($event): void {
        if (this.isRetracted) {
            return;
        }
        this.content = '';
        this.editable = false;
        this.changeDetector.detectChanges();
        this.onDeleteClick.emit($event);
    }

    public onChange(event): void {
        const linkHidden = this.elementRef.nativeElement.querySelector('.ql-hidden');
        if (event.range == null && event.oldRange != null && linkHidden) {
            this.editable = false;
            if (this.content === ' ') {
                this.content = null;
            }
            this.changeDetector.detectChanges();
        }
    }

    public onInit(event): void {
        const limit: number = +this.maxLength;
        const textChangeCallback = (function(delta, old, source) {
            if (event.editor.getLength() > limit) {
                event.editor.deleteText(limit, event.editor.getLength());
            }
            let htmlText = event.editor.container.firstChild.innerHTML;
            if (event.editor.getText().trim().length === 0) {
                htmlText = null;
            }
            this.quillEditor.onModelChange(htmlText);
            this.quillEditor.onModelTouched();
            this.propagateChange(htmlText);
        }).bind(this);

        event.editor.on('text-change', textChangeCallback);
        event.editor.focus();
    }

    escapeTextEditor() {
        this.editable = false;
    };

    public onTextChange(event): void {
        this.propagateChange(event.htmlValue);
    }

    public filterHTMLTags(content: string): string {
        content = content.replace(new RegExp('<header', 'g'), '<div');
        content = content.replace(new RegExp('</header', 'g'), '</div');
        return content;
    }

    public onMoveUp(): void {
        this.moveUp.emit();
    }
    public onMoveDown(): void {
        this.moveDown.emit();
    }
}
